module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "salemainpage"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px 32px 16px 16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticClass: "contentcard"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('a-button-group', [_c('a-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.gotopage('skumanagement')
      }
    }
  }, [_vm._v("SKU管理")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.gotopage('terminalmanagement')
      }
    }
  }, [_vm._v("端管理")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "disabled": _vm.is_old_data
    },
    on: {
      "click": _vm.targetbtn
    }
  }, [_vm._v("目标制定")]), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newlogbtn
    }
  }, [_vm._v("新增记录")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "float": "right"
    }
  }, [_c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.year
    },
    on: {
      "change": _vm.yearChange
    }
  }, _vm._l((_vm.yearlist), function(year, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": year
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(year) + "\n\t\t\t\t\t\t\t\t")])
  }), 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.quarter
    },
    on: {
      "change": _vm.quarterChange
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t第一季度\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t第二季度\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t第三季度\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t第四季度\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('a-button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search_btn
    }
  }, [_vm._v("搜索")])], 1)], 1), _vm._v(" "), (_vm.reloading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "rgba(0,0,0,0.05)",
      "border-radius": "4px",
      "padding": "30px 50px"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), (!_vm.reloading) ? _c('div', [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.data,
      "scroll": _vm.scroll_info,
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "expandedRowRender",
      fn: function(record, index, indent) {
        return _c('a-table', {
          attrs: {
            "columns": _vm.innerColumns,
            "dataSource": _vm.data[index].innerData,
            "size": "middle",
            "pagination": false,
            "bordered": ""
          },
          scopedSlots: _vm._u([{
            key: "operation",
            fn: function(text, record) {
              return _c('span', {}, [_c('a', {
                attrs: {
                  "disabled": !record.can_compile
                },
                on: {
                  "click": function($event) {
                    return _vm.bianjibtn(record)
                  }
                }
              }, [_vm._v("修改")])])
            }
          }], null, false, 2636988835)
        })
      }
    }], null, false, 3298811091)
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "sale_rule"
  }, [_c('p', {
    staticClass: "sale_rule_title"
  }, [_vm._v("基数值：")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("3月的实际销售量*3=季度基数值")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_title"
  }, [_vm._v("激励原则：")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("从4月开始设定奖金池，以季度为单位计算奖金池金额，季度发放。奖励部分：以季度为单位，超出基数值的部分，按照“超出数量”*“奖金系数金额”的计算方式，计入奖金池。")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("扣除部分：每个月损耗按照成本从奖金池中扣除，包括产品成本以及运输成本。损耗部分包括未售出报废以及作为赠品赠送部分。")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("发放：7月15号，奖金池内金额按照约定比例，与工资一并扣税、发放。")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_title"
  }, [_vm._v("在规则内的渠道：")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("所有现有线上渠道销售，包括：")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info",
    staticStyle: {
      "text-indent": "4em"
    }
  }, [_vm._v("淘宝店“Freshin鲜入为主官方店”；")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info",
    staticStyle: {
      "text-indent": "4em"
    }
  }, [_vm._v("小程序“Freshin鲜入为主旗舰店”中钻石、VIP以及普通会员的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_title"
  }, [_vm._v("不在规则内的渠道：")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("1、线下自提渠道")]), _vm._v(" "), _c('p', {
    staticClass: "sale_rule_info"
  }, [_vm._v("2、小程序渠道皇冠会员销量")])])]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "目标制定",
      "visible": _vm.targetvisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.targetOk,
      "cancel": _vm.targetCancel
    }
  }, [_c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("季度")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.year,
      "disabled": ""
    }
  }, _vm._l((_vm.yearlist), function(year, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": year
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(year) + "\n\t\t\t\t")])
  }), 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.quarter,
      "disabled": ""
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("\n\t\t\t\t\t第一季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("\n\t\t\t\t\t第二季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("\n\t\t\t\t\t第三季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("\n\t\t\t\t\t第四季度\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("选择商品")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "value": _vm.target.sku_id,
      "placeholder": "请选择商品"
    },
    on: {
      "change": _vm.target_sku
    }
  }, _vm._l((_vm.data), function(sku, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": sku.id,
        "disabled": sku.target != '未设置目标'
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(sku.sku_name + " ") + _vm._s(sku.target != '未设置目标' ? '目标已设置' : '') + "\n\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("季度目标")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入季度目标"
    },
    model: {
      value: (_vm.target.target),
      callback: function($$v) {
        _vm.$set(_vm.target, "target", $$v)
      },
      expression: "target.target"
    }
  })], 1)]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "数据修改",
      "visible": _vm.compilevisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.compileOk,
      "cancel": _vm.compileCancel
    }
  }, [_c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("销售数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入销售数"
    },
    model: {
      value: (_vm.compile.sale_number),
      callback: function($$v) {
        _vm.$set(_vm.compile, "sale_number", $$v)
      },
      expression: "compile.sale_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("货损数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入货损数"
    },
    model: {
      value: (_vm.compile.damage_number),
      callback: function($$v) {
        _vm.$set(_vm.compile, "damage_number", $$v)
      },
      expression: "compile.damage_number"
    }
  })], 1)]), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "新增记录",
      "width": 600,
      "visible": _vm.newlogvisible,
      "confirmLoading": _vm.confirmLoading
    },
    on: {
      "ok": _vm.newlogOk,
      "cancel": _vm.newlogCancel
    }
  }, [_c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("记录时间")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.year,
      "disabled": ""
    }
  }, _vm._l((_vm.yearlist), function(year, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": year
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(year) + "\n\t\t\t\t")])
  }), 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.quarter,
      "disabled": ""
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("\n\t\t\t\t\t第一季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("\n\t\t\t\t\t第二季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("\n\t\t\t\t\t第三季度\n\t\t\t\t")]), _vm._v(" "), _c('a-select-option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("\n\t\t\t\t\t第四季度\n\t\t\t\t")])], 1), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "value": _vm.newlog.month,
      "placeholder": "请选择月份"
    },
    on: {
      "change": _vm.newlog_month
    }
  }, _vm._l((_vm.month_list), function(month, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": month.value
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(month.name) + "\n\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("选择商品")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "value": _vm.newlog.sku_id,
      "placeholder": "请选择商品"
    },
    on: {
      "change": _vm.newlog_sku
    }
  }, _vm._l((_vm.data), function(sku, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": sku.id
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(sku.sku_name) + "\n\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("选择记录端")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "value": _vm.newlog.terminal_id,
      "placeholder": "请选择记录端"
    },
    on: {
      "change": _vm.newlog_terminal
    }
  }, _vm._l((_vm.terminal_list), function(terminal, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": terminal.id
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(terminal.terminal_name) + "\n\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("销售数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入销售数"
    },
    model: {
      value: (_vm.newlog.sale_number),
      callback: function($$v) {
        _vm.$set(_vm.newlog, "sale_number", $$v)
      },
      expression: "newlog.sale_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "newsku"
  }, [_c('span', {
    staticClass: "newskutext"
  }, [_vm._v("货损数")]), _vm._v(" "), _c('a-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入货损数"
    },
    model: {
      value: (_vm.newlog.damage_number),
      callback: function($$v) {
        _vm.$set(_vm.newlog, "damage_number", $$v)
      },
      expression: "newlog.damage_number"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c66c2e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/sale/salemainpage/index.vue
// module id = 2370
// module chunks = 1